import { LateChange, NegativeCompLoan, OverrideLine, PayeeSummary, ValidationCheck } from '../types/commission';

export const periodStats = {
  loans: 41,
  /** All lines, including the TL / Director rows. */
  lines: 93,
  adjustmentsPending: 2,
};

export const TL_UNIT_COUNT_REVIEW_NOTE = 'Under review: in main, TL/Director fee rows may be counted as units; intended behavior is no bonus for TL/Director.';

export const payeeSummaries: PayeeSummary[] = [
  { id: 'p-alex', name: 'Alex Rivera', role: 'Loan Officer', branch: 'Troy', units: 7, volume: 2485400, base: 28447.5, bonus: 0, overrides: 0, overridesAdjusted: 0, manual: -140, adjustedTotal: 25199.17, note: 'Troy ≥ $1.5M → base 125 · bonus 0 (main)' },
  { id: 'p-jordan', name: 'Jordan Lee', role: 'Loan Officer', branch: 'Troy', units: 5, volume: 1640000, base: 20500, bonus: 0, overrides: 0, overridesAdjusted: 0, manual: 2620, adjustedTotal: 23075.46, note: '40% split of LN-2026-004790', noteIsNew: true },
  { id: 'p-casey', name: 'Casey Nguyen', role: 'Loan Officer', branch: 'Troy', units: 2, volume: 618400, base: 6184, bonus: 0, overrides: 0, overridesAdjusted: 0, manual: 0, adjustedTotal: 6184, note: 'Unlicensed · Standard 100 bps' },
  { id: 'p-sam', name: 'Sam Patel', role: 'Team Lead', branch: 'Troy', units: 4, volume: 1302000, base: 13020, bonus: 0, overrides: 4743.8, overridesAdjusted: 4243.78, manual: 0, adjustedTotal: 17263.78, note: 'TL row 10 bps — from employee record: Team Lead BPS' },
  { id: 'p-morgan', name: 'Morgan Brooks', role: 'Loan Officer', branch: 'Miami', units: 8, volume: 2880000, base: 43200, bonus: 0, overrides: 0, overridesAdjusted: 0, manual: 0, adjustedTotal: 39150, note: 'Miami ≥ $2M → 150 bps · bonus 0 (Miami, main)' },
  { id: 'p-angelo', name: 'Angelo Jarbo', role: 'Director/DL', branch: 'Miami', units: 0, volume: 0, base: 0, bonus: 0, overrides: 1440, overridesAdjusted: 1305, manual: 0, adjustedTotal: 1305, note: 'Director row 5 bps — from employee record: Director BPS' },
  { id: 'p-riley', name: 'Riley Chen', role: 'Loan Officer', branch: 'Arizona', units: 2, volume: 640000, base: 6400, bonus: 0, overrides: 0, overridesAdjusted: 0, manual: 0, adjustedTotal: 6400 },
  { id: 'p-quinn', name: 'Quinn Harper', role: 'Team Lead', branch: 'Arizona', units: 3, volume: 1050000, base: 10500, bonus: 0, overrides: 2750, overridesAdjusted: 2708, manual: 0, adjustedTotal: 13208, note: 'TL row 10 bps — from employee record: Team Lead BPS' },
  { id: 'p-taylor', name: 'Taylor Ortiz', role: 'Loan Officer', branch: 'Arizona', units: 6, volume: 2110000, base: 21100, bonus: 0, overrides: 0, overridesAdjusted: 0, manual: 210, adjustedTotal: 21310, note: 'Arizona flat 100 bps · bonus 0 (main)' },
  { id: 'p-drew', name: 'Drew Kim', role: 'Loan Officer', branch: 'Remote', units: 4, volume: 1480000, base: 17760, bonus: 0, overrides: 0, overridesAdjusted: 0, manual: 0, adjustedTotal: 17760, note: 'Custom Base BPS 120 · custom bonus 0' },
];

export const parityStats = {
  /** Legacy dashboard total (Adjusted basis — pays). */
  legacyAdjusted: 170855.41,
  /** Legacy stored total (Stored / unadjusted basis — reference). */
  legacyStored: 178735.3,
  mismatches: 0,
};

export const TL_FLOW_NOTE = 'In the Salesforce git repo this flow (NCS Update TL Commission) is marked Obsolete, so this rule is unconfirmed in production.';

export const overrideLines: OverrideLine[] = [
  {
    id: 'ov-sam',
    name: 'Sam Patel',
    role: 'Team Lead',
    branch: 'Troy',
    ruleKey: 'V1-TL-RATE',
    bps: 10,
    bpsField: 'Team Lead BPS',
    adjustedVolume: 4243778.46,
    storedVolume: 4743800,
    adjustedAmount: 4243.78,
    storedAmount: 4743.8,
    skipRule: 'Row skipped when Opportunity Owner = Team Leader',
    selfGenNote: 'Sam’s 4 own loans ($1,302,000.00) skipped — self-gen',
  },
  {
    id: 'ov-quinn',
    name: 'Quinn Harper',
    role: 'Team Lead',
    branch: 'Arizona',
    ruleKey: 'V1-TL-RATE',
    bps: 10,
    bpsField: 'Team Lead BPS',
    adjustedVolume: 2708000,
    storedVolume: 2750000,
    adjustedAmount: 2708,
    storedAmount: 2750,
    skipRule: 'Row skipped when Opportunity Owner = Team Leader',
    selfGenNote: 'Quinn’s 3 own loans ($1,050,000.00) skipped — self-gen',
  },
  {
    id: 'ov-angelo',
    name: 'Angelo Jarbo',
    role: 'Director/DL',
    branch: 'Miami',
    ruleKey: 'V1-DIR-RATE',
    bps: 5,
    bpsField: 'Director BPS',
    adjustedVolume: 2610000,
    storedVolume: 2880000,
    adjustedAmount: 1305,
    storedAmount: 1440,
    skipRule: 'Row skipped when Opportunity Owner = Division Leader',
    selfGenNote: 'No loans owned by Angelo in October',
    writesTo: 'Division Leader Commissions',
  },
];

export const negativeCompLoans: NegativeCompLoan[] = [
  {
    loanNumber: 'LN-2026-004744',
    borrower: 'D. Example',
    loanOfficer: 'Alex Rivera',
    branch: 'Troy',
    loanAmount: 198800,
    totalCompPct: 0.6,
    revenue: 1192.8,
    feeShort: 1395,
    revenueAfterShort: -202.2,
    divisorPct: 3.25,
    adjustedAmount: 0,
  },
  {
    loanNumber: 'LN-2026-004877',
    borrower: 'F. Mockup',
    loanOfficer: 'Morgan Brooks',
    branch: 'Miami',
    loanAmount: 270000,
    totalCompPct: 0.4,
    revenue: 1080,
    feeShort: 1395,
    revenueAfterShort: -315,
    divisorPct: 3.25,
    adjustedAmount: 0,
  },
];

export const closeChecks: ValidationCheck[] = [
  { id: 'calculated', label: 'All funded loans calculated', detail: '41 of 41 funded loans have commission lines', status: 'pass' },
  { id: 'plan-match', label: 'Every loan matched a plan', detail: 'All loans matched LO Standard Plan v1 parity', status: 'pass' },
  { id: 'rates', label: 'TL / Director rates read from the employee record (Team Lead BPS / Director BPS)', detail: '24 TL / Director rows included in the period totals', status: 'pass' },
  { id: 'parity', label: 'Parity check passed', detail: 'Legacy vs new: 0 mismatches on adjusted and stored totals', status: 'pass', tag: 'Cutover period' },
  { id: 'negative', label: 'Negative comp loans flagged', detail: '2 loans — comp % < 0 → Adjusted Loan Amount $0.00 (main). Alert recipients: open question.', status: 'warning' },
  { id: 'late', label: 'Loans edited after last calculation', detail: '2 loans will post as Adjustment lines to November 2026 (NEW)', status: 'warning' },
];

export const lateChanges: LateChange[] = [
  {
    id: 'lc-1',
    loanNumber: 'LN-2026-004790',
    borrower: 'K. Mockley',
    loanOfficer: 'Alex Rivera / Jordan Lee (60 / 40 split)',
    field: 'Loan Amount',
    from: '$524,000.00',
    to: '$530,000.00',
    estImpact: 81,
    impactDetail: 'Alex $6,000.00 × 1.25% × 60% = $45.00 · Jordan $6,000.00 × 1.25% × 40% = $30.00 · Sam Patel TL $6,000.00 × 0.10% = $6.00',
  },
  {
    id: 'lc-2',
    loanNumber: 'LN-2026-004921',
    borrower: 'B. Specimen',
    loanOfficer: 'Taylor Ortiz (Arizona)',
    field: 'Loan Amount',
    from: '$389,000.00',
    to: '$384,500.00',
    estImpact: -45,
    impactDetail: '−$4,500.00 × 1.00% (Arizona flat 100 bps, bonus 0) = −$45.00',
  },
];
